import { render, staticRenderFns } from "./MessageSnackList.vue?vue&type=template&id=40a4a362&scoped=true&"
import script from "./MessageSnackList.vue?vue&type=script&lang=js&"
export * from "./MessageSnackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a4a362",
  null
  
)

export default component.exports